// Per-property contact data for Amrut Group.
// Phones for Aura/Seafood/Inn are public listings. Bakery + Jewellers
// phones are placeholders (00000 11111) until the client provides real numbers.
// Map URLs are the real client-provided Google Maps pins.
// Email IDs are intentionally omitted — to be added once configured.

export const CONTACTS = {
  aura: {
    name: "Amrut Aura",
    phone: "+91 78996 28831",
    phoneRaw: "917899628831",
    whatsappRaw: "917899628831",
    address: "Civil Court Road, Next to Amrut Jewellers, Karwar, Karnataka 581301",
    mapUrl: "https://www.google.com/maps/search/Amrut%20Aura/@14.81047286,74.13042178,17z?hl=en",
  },
  seafood: {
    name: "Amrut Seafood Restaurant",
    phone: "+91 83822 26609",
    phoneRaw: "918382226609",
    whatsappRaw: "918382226609",
    address: "Cutinho Road, Near Syndicate Bank, Karwar, Karnataka 581301",
    mapUrl: "https://www.google.com/maps/search/Hotel%20Amrut/@14.80907274,74.13031677,17z?hl=en",
  },
  inn: {
    name: "Amrut Inn",
    phone: "+91 81234 30759",
    phoneRaw: "918123430759",
    whatsappRaw: "918123430759",
    address: "Konekar Wada, Next to Max Showroom, Karwar, Karnataka 581301",
    mapUrl: "https://www.google.com/maps?q=14.8087514,74.1336202&z=17&hl=en",
  },
  bakery: {
    name: "Amrut Delight",
    phone: "+91 63630 73017",
    phoneRaw: "916363073017",
    whatsappRaw: "916363073017",
    address: "Opposite Karwar Bus Depot, Karwar, Karnataka 581301",
    mapUrl: "https://www.google.com/maps/search/?api=1&query=Amrut+Delight+Karwar",
  },
  jewellers: {
    name: "Amrut Jewellers",
    phone: "+91 94498 13489",
    phoneRaw: "919449813489",
    whatsappRaw: "919449813489",
    address: "Civil Court Road, Karwar, Karnataka 581301",
    mapUrl: "https://www.google.com/maps/search/Amrut%20Jewellers/@14.81082712,74.13071726,17z?hl=en",
  },
};
